export interface AuthenticatorProps {
    defaultTab: AuthenticatorTabName
}

export enum AuthenticatorTabName {
    Login = 'Login', // cannot be camel case because of antd tabs
    forgotPassword = 'Forgot Password',
}
